import { render, staticRenderFns } from "./MotionSensorDevice.vue?vue&type=template&id=0b1c7450"
import script from "./MotionSensorDevice.vue?vue&type=script&lang=js"
export * from "./MotionSensorDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports